import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5efad572"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "tw-flex tw-gap-[6px]" }
const _hoisted_3 = { class: "tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%] title" }
const _hoisted_4 = { class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%] size" }
const _hoisted_5 = {
  key: 0,
  class: "tw-h-[14px] tw-w-[14px]"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Lock-6--Streamline-Ultimate.svg",
  class: "tw-mb-[14px]",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("desc", null, "Lock 6 Streamline Icon: https://streamlinehq.com"),
  /*#__PURE__*/_createElementVNode("defs"),
  /*#__PURE__*/_createElementVNode("title", null, "lock-6"),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.25 9.75h13.5s1.5 0 1.5 1.5v10.5s0 1.5 -1.5 1.5H5.25s-1.5 0 -1.5 -1.5v-10.5s0 -1.5 1.5 -1.5",
    fill: "none",
    stroke: "#878787",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.75 9.75V6a5.25 5.25 0 0 1 10.5 0v3.75",
    fill: "none",
    stroke: "#878787",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.75 16.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0",
    fill: "none",
    stroke: "#878787",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { PropType, ref } from "vue";
import PinIcon from "../svgs/pinIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'attachment',
  props: {
  title: {
    type: String as PropType<string>,
    default: "attachmentname.pdf",
  },
  size: {
    type: String as PropType<string>,
    default: "-1KB",
  },
  href: {
    type: String as PropType<string>,
    default: "#",
  },
  isShowClock: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.href,
    class: "tw-flex tw-items-center tw-gap-[4px] tw-w-[fit-content]",
    target: "_blank"
  }, [
    _createVNode(PinIcon, { class: "tw-h-[15px] tw-w-[14px]" }),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.size), 1),
      (__props.isShowClock)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})